// File: frontend/src/components/common/VenueCoBrand.tsx
//
// "FANTASY FUTBOL x <bar logo or name>" in the header while a partner bar's page is
// open (contexts/VenueBrandContext.tsx). Mobile stacks the two (the centre
// slot is half the header); desktop sets them in a row.

import React from 'react';
import { useActiveVenue } from '@/contexts/VenueBrandContext';

const VenueCoBrand: React.FC<{ variant: 'mobile' | 'desktop' }> = ({ variant }) => {
  const venue = useActiveVenue();
  if (!venue) return <>FANTASY FUTBOL</>;
  if (variant === 'mobile') {
    return (
      <span className="inline-flex flex-col items-center gap-0.5 leading-none">
        <span className="text-[10px] tracking-wider">FANTASY FUTBOL x</span>
        {venue.headerText
          ? <span className="text-[19px]" style={venue.headerTextStyle}>{venue.headerText}</span>
          : <img src={venue.logo} alt={venue.name} style={{ height: Math.min(venue.logoHeight, 26) }} className="w-auto max-w-full object-contain" />}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2">
      <span>FANTASY FUTBOL</span>
      <span className="text-sm text-gray-400" aria-hidden="true">x</span>
      {venue.headerText
        ? <span style={venue.headerTextStyle}>{venue.headerText}</span>
        : <img src={venue.logo} alt={venue.name} style={{ height: venue.logoHeight }} className="w-auto object-contain" />}
    </span>
  );
};

export default VenueCoBrand;
